import * as React from 'react';
import { usePage } from '@inertiajs/react';
import { assetUrl } from '../../utils/assetUrl';
import { trackSignupClicked } from '../../utils/tracking';
import { route } from '../../utils/route';

interface WholesaleHeroProps {
  onDownloadClick: () => void;
}

export function WholesaleHero({ onDownloadClick }: WholesaleHeroProps) {
  const { cdnUrl } = usePage<{ cdnUrl: string }>().props;
  const heroImg = assetUrl(cdnUrl, '/img/gastro-hero.webp');

  return (
    <section className="wholesale-hero">
      <style>{`
        .wholesale-hero {
          position: relative;
          background: url(${heroImg}) center center/cover no-repeat;
          padding: 100px 0 110px;
          min-height: 420px;
          display: flex;
          align-items: center;
        }
        .wholesale-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.65);
        }
        .wholesale-hero-inner {
          position: relative;
          z-index: 1;
          max-width: 800px;
          margin: 0 auto;
          padding: 0 24px;
          text-align: center;
        }
        .wholesale-hero h1 {
          font-size: 38px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 16px;
          line-height: 1.2;
        }
        .wholesale-hero .wholesale-hero-sub {
          font-size: 20px;
          color: rgba(255,255,255,0.9);
          margin: 0 0 12px;
          font-weight: 500;
        }
        .wholesale-hero .wholesale-hero-desc {
          font-size: 17px;
          color: rgba(255,255,255,0.7);
          margin: 0 0 36px;
        }
        .wholesale-hero-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .wholesale-btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          background: #1EAA25;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          border-radius: 8px;
          text-decoration: none;
          transition: background 0.2s;
        }
        .wholesale-btn-primary:hover {
          background: #178f1e;
          color: #fff;
          text-decoration: none;
        }
        .wholesale-btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          background: transparent;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          border: 2px solid rgba(255,255,255,0.6);
          border-radius: 8px;
          text-decoration: none;
          transition: all 0.2s;
          cursor: pointer;
        }
        .wholesale-btn-secondary:hover {
          background: rgba(255,255,255,0.1);
          border-color: #fff;
          color: #fff;
          text-decoration: none;
        }
        @media (max-width: 640px) {
          .wholesale-hero {
            padding: 70px 0 80px;
            min-height: auto;
          }
          .wholesale-hero h1 {
            font-size: 28px;
          }
          .wholesale-hero .wholesale-hero-sub {
            font-size: 17px;
          }
          .wholesale-hero-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .wholesale-btn-primary, .wholesale-btn-secondary {
            justify-content: center;
          }
        }
      `}</style>
      <div className="wholesale-hero-inner">
        <h1>Precios mayoristas para tu negocio</h1>
        <p className="wholesale-hero-sub">Descuentos de hasta 8% según tu volumen de compra mensual.</p>
        <p className="wholesale-hero-desc">Explorá nuestros precios, compará los niveles de descuento y descargá la lista completa.</p>
        <div className="wholesale-hero-ctas">
          <a href={route('company.create')} className="wholesale-btn-primary" onClick={() => trackSignupClicked('precios-mayoristas', 'hero')}>
            <i className="fa fa-user-plus" /> Crear cuenta mayorista
          </a>
          <button onClick={onDownloadClick} className="wholesale-btn-secondary">
            <i className="fa fa-file-excel" /> Descargar lista de precios
          </button>
        </div>
      </div>
    </section>
  );
}
